import React from 'react';
import { RaisedButton, Dialog } from 'material-ui';

export default class extends React.Component {
  cancelar = () => {
    this.props.cancelar();
  };
  render() {
    return (
      <Dialog
        title="Confirme para eliminar"
        actions={[
          <RaisedButton key={1} label="Cancelar" primary={true} onTouchTap={this.cancelar} fullWidth={true} />,
          <RaisedButton key={2} label="Eliminar" secondary={true} keyboardFocused={true} onTouchTap={this.props.confirmar} fullWidth={true} className="pt-15" />,
        ]}
        modal={false}
        className="confirmationDialog"
        open={this.props.eliminarId ? true : false}
        onRequestClose={this.props.cancelar}
      >
        {this.props.content}
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/general/components/eliminarConfirmacion.js